export interface ISolicitacaoChatMessage {
  texto: string;
  tipo: SolicitacaoChatMessageTypeEnum;
  anexoId?: string;
  anexoUrl?: string;
  anexoNome?: string;
  anexoTipo?: string;
  usuarioId?: string;
  usuarioNome?: string;
  dataDeEnvio?: string;
  tipoMensagem?: ISolicitacaoChatMessageType
}

export interface ISolicitacaoChatMessageType {
  display: string;
  key: string;
}

export enum SolicitacaoChatMessageTypeEnum {
  inicioAgendamento = 'InicioAgendamento',
  fimAgendamento = 'FimAgendamento',
  inicioAutorizacao = 'InicioAutorizacao',
  fimAutorizacao = 'FimAutorizacao',
  inicioOrcamento = 'InicioOrcamento',
  fimOrcamento = 'FimOrcamento',
  texto = 'Texto',
  enviadoParaAutorizacao = 'EnviadoParaAutorizacao',
  enviadoParaAgendamento = 'EnviadoParaAgendamento',
  enviadoParaOrcamento = 'EnviadoParaOrcamento',
  anexo = 'Anexo',
}
